import type { ApplicationInfo, DriverProfile, UpdateDriverRequest } from '@@/api/types/Application'
import type { ApiPaginatedResponse, ApiResponse } from '@@/api/types/Api'
import { ApiServiceBase } from '@@/api/services/ApiServiceBase'
import type { Driver, UpdatePasswordRequest } from '../types/Authentication'

export default class ApplicationService extends ApiServiceBase {
  async info(): Promise<ApplicationInfo> {
    return await this.call('/')
  }

  async getFleet(id: string, query?: object | null): Promise<ApiResponse<object>> {
    return await this.call(`/v1/fleets/${id}`, query ?? {})
  }

  async fleets(query?: object | null): Promise<ApiPaginatedResponse<object>> {
    return await this.call('/v1/fleets', query ?? {})
  }

  async operatingAreas(query?: object | null): Promise<ApiPaginatedResponse<object>> {
    return await this.call('/v1/operating-areas', query ?? {})
  }

  async driver(query?: string | null): Promise<ApiResponse<Driver>> {
    return await this.call(`/v1/driver${query ? query : ''}`)
  }

  async driverProfile(): Promise<ApiResponse<DriverProfile>> {
    return await this.call(`/v1/driver/profile`)
  }

  async updateDriver(id: string | number, data: UpdateDriverRequest): Promise<ApiResponse<Driver>> {
    return await this.call(`/v1/driver/${id}`, {
      method: 'put',
      body: data,
    })
  }

  async updatePassword(data: UpdatePasswordRequest): Promise<{ status: string }> {
    return await this.call('/v1/user/update-password', {
      method: 'put',
      body: data,
    })
  }
}
